// The Main Site Object
let Terroir = {

    btns          : document.querySelectorAll('.vigna-btn'),
    sections      : document.querySelectorAll('.vigna'),
    activeBtn     : document.querySelector('.vigna.open'),
    activeSection : document.querySelector('.vigna-btn.open'),

    // Init Function
    liftoff : () => {
        Terroir.onClickExpandSection()
    },

    // Show/Hide The Main Navigation
    onClickExpandSection : () => {
        Terroir.btns.forEach((btn) => {
            btn.addEventListener('click' , () => {
                
                let id     = btn.dataset.id;
                let target = document.getElementById(id);

                if (btn != Terroir.activeBtn && target != Terroir.activeSection) {

                    Terroir.activeBtn.classList.remove('open')
                    Terroir.activeSection.classList.remove('open')

                    btn.classList.add('open')
                    target.classList.add('open')

                }
            })
        })
    }




}

// Launch The Script
Terroir.liftoff()